import React, { useState } from 'react';
import { Modal, Button, Form, InputGroup, Range } from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import { api } from '../apiService';
import { toast } from 'react-toastify';
import upload_svg from '../img/upload.svg';

export const SettingDialog = ({ show }) => {
  const [showModal, setShowModal] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(['setting']);

  const handleClose = () => {
    setShowModal(!showModal);
  };

  const handleIs_convert_pdfChange = (e) => {
      const currentSettings = cookies.setting || {};
      setCookie('setting', {...currentSettings,
        is_convert_pdf: e.target.value
      }, { path: '/' });
  };

  const handleTemplate_nameChange = (e) => {
      const currentSettings = cookies.setting || {};
      setCookie('setting', {...currentSettings,
        template_name: e.target.value
      }, { path: '/' });
  };

  const handleCustom_templateChange = (e) => {
      const currentSettings = cookies.setting || {};
      setCookie('setting', {...currentSettings,
        custom_template: e.target.value
      }, { path: '/' });
  };

  const handleUploadCVTemplate = async (e) => {
    const file = e.target.files[0]; // 1. Grab the first file
    if (file) {
      if (file.size > 2000000) {
        toast.error("File is too large! Please choose an image under 2MB.");
        return;
      }
      console.log("handleUploadCVTemplate:");
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', file.type);
      const [data, error] = await api.postFile('profiles/upload_template/', formData,);
      if (data) {
        const fileame = file.name;
        handleCustom_templateChange({target: {value: fileame.substring(0, fileame.lastIndexOf('.'))}});
        toast.success(`CV template successfully uploaded.`);
      }
    }
  };

  return (
    <>
      <Modal show={showModal ^ show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Setting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>CV/Cover output format:</Form.Label>
            <Form.Select name="is_convert_pdf" value={cookies?.setting?.is_convert_pdf} onChange={ handleIs_convert_pdfChange } aria-label="Default select example" >
              <option value="false">.docx</option>
              <option value="true">.pdf</option>
            </Form.Select>

          </Form.Group>
          <Form.Group>
            <Form.Label>CV Template</Form.Label>
            <Form.Select name="template_name" value={cookies?.setting?.template_name} onChange={ handleTemplate_nameChange } aria-label="Default select example" >
              <option>cv-template1</option>
              <option>cv-template2</option>
              <option>cv-custom</option>
            </Form.Select>

            <Form.Label>Custom CV Template</Form.Label>
            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon3">[youemail]-</InputGroup.Text>
              <Form.Control type="text" name="custom_template" value={cookies?.setting?.custom_template} disabled={cookies?.setting?.template_name != "cv-custom"} onChange={ handleCustom_templateChange } placeholder="my-template" aria-describedby="basic-addon3"/>

              <label htmlFor="custom-template-upload" style={{ cursor: 'pointer' }}>
                <img src={upload_svg} alt="Upload CV Template" className="rounded-circle" height="32px" width="32px" />
              </label>
              <Form.Control type="file" id="custom-template-upload" onChange={(e) => handleUploadCVTemplate(e)} className="d-none" accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />
            </InputGroup>

          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
